var React = require('react');

function SChevronRightMedium18N (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.99,9a.99678.99678,0,0,0-.29327-.70734L7.71734,4.30329a.9999.9999,0,0,0-1.42022,1.4079l.0037.00371L9.58594,9,6.30327,12.28268a.9999.9999,0,0,0,1.411,1.41716l.00069-.00068,3.9818-3.9918A.99669.99669,0,0,0,11.99,9Z","fill":"var(--iconFill, #464646)"}));
}

SChevronRightMedium18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SChevronRightMedium18N;

SChevronRightMedium18N.default = SChevronRightMedium18N;
